import { ValidationIssue } from "../../rule-engine-core/Common/IDesignValidationProvider";
import { Box } from "@mui/system";
import React from "react";
import { UILayer } from "./UILayer";
import { UIButton } from "./UIButton";
import { UIErrorDisplay } from "./UIErrorDisplay";
import { UILabel } from "./UILabel";

export interface UIStandardLayerProps {
    open: boolean;
    onClose?: () => void;
    title: string;
    primaryActionText?: string;
    onPrimaryAction?: () => void;
    secondaryActionText?: string;
    onSecondaryAction?: () => void;
    renderUI: () => JSX.Element;
    validationIssues?: ValidationIssue[];
    fullScreen?: boolean;
    fullWidth?: boolean;
}

export function UIStandardLayer(props: UIStandardLayerProps) {
    return (
        <UILayer
            onClose={props.onClose}
            open={props.open}
            showCloseButton={props.onClose !== undefined}
            fullScreen={props.fullScreen}
            fullWidth={props.fullWidth}
            renderUI={() => {
                return (
                    <>
                        <Box
                            display={"flex"}
                            flexDirection={"column"}
                            padding={"20px"}
                        >
                            <Box
                                paddingBottom={"10px"}
                                display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"left"}
                            >
                                <UILabel variant={"section_title"}>{props.title}</UILabel>
                            </Box>
                            <UIErrorDisplay validationBreaks={props.validationIssues}></UIErrorDisplay>
                            <Box
                                paddingTop={"10px"}
                                paddingBottom={"10px"}
                                display={"flex"}
                                flexDirection={"column"}
                                justifyContent={"left"}
                            >
                                {props.renderUI()}
                            </Box>
                            {!props.secondaryActionText && props.primaryActionText && (
                                <Box
                                    display={"flex"}
                                    flexDirection={"row"}
                                    paddingTop={"15px"}
                                    justifyContent={"right"}
                                >
                                    <UIButton onClick={props.onPrimaryAction}>{props.primaryActionText}</UIButton>
                                </Box>
                            )}
                            {props.secondaryActionText && props.primaryActionText && (
                                <Box
                                    display={"flex"}
                                    flexDirection={"row"}
                                    paddingTop={"15px"}
                                    justifyContent={"space-between"}
                                    alignItems={"center"}
                                >
                                    <UIButton
                                        onClick={props.onSecondaryAction}
                                        variant={"link_underlined"}
                                    >
                                        {props.secondaryActionText}
                                    </UIButton>
                                    <UIButton onClick={props.onPrimaryAction}>{props.primaryActionText}</UIButton>
                                </Box>
                            )}
                        </Box>
                    </>
                );
            }}
        ></UILayer>
    );
}
